// bd-deepcontext-b4zw — the icon half of the status helpers (jobStatus.ts holds
// the JSX-free half). Same elements and classes ScheduledJobs.tsx rendered
// inline, so the badges look identical.
import {
  CheckCircleIcon,
  ClockIcon,
  CogIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import type { JobStatusKind } from "./jobStatus";

export const getJobStatusIcon = (kind: JobStatusKind): React.ReactElement => {
  switch (kind) {
    case "running":
      return <CogIcon className="h-3 w-3 animate-spin" />;
    case "active":
      return <CheckCircleIcon className="h-3 w-3" />;
    default:
      return <ClockIcon className="h-3 w-3" />;
  }
};

export const getRunStatusIcon = (status: string): React.ReactElement => {
  switch (status) {
    case "pending":
      return <ClockIcon className="h-4 w-4" />;
    case "running":
      return <CogIcon className="h-4 w-4 animate-spin" />;
    case "completed":
      return <CheckCircleIcon className="h-4 w-4" />;
    case "failed":
      return <XCircleIcon className="h-4 w-4" />;
    default:
      return <ExclamationTriangleIcon className="h-4 w-4" />;
  }
};
